module.exports = __webpack_public_path__ + "img/logogerofotis.136aab2d.png";